export default __webpack_public_path__ + "static/application-9146057ba19ebc6a498cc911a834e4dd.png";